'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: THIS SERVICE IS USEFUL IN COMMUNICATING WITH THE WCF METHODS OF STICKY NOTES
//*******EFFECTIVE FILES: ../Views/StickyNotes/..
//*******CREATED BY: 
//*******CREATED DATE: 
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Home').service('ROSCommonService', ['CommonService', function (CommonService) {

	/// ################ METHOD TO GET ROS OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST WEB     BLOCK START #########################  
	///*******PURPOSE:THIS  METHOD TO GET ROS OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST WEB
	///*******CREATED BY:AMRANATH
	///*******CREATED DATE: 04/04/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************

	this.rosserviceGetROSObjectsDefaultOptionsLinkedPhysiciansListWeb = function (postData) {
		postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHRROS() + "GetROSObjectsDefaultOptionsLinkedPhysiciansListWeb", postData).then(function (result) {
			return result;
		});
	}
	/// ################ METHOD TO GET ROS OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST WEB     BLOCK END #########################

	/// ################ METHOD TO GET ALL DEFAULT OPTIOS LIST BLOCK START #########################  
	/// *******PURPOSE: THIS METHOD TO GET ALL DEFAULT OPTIOS LIST
	///*******CREATED BY: PHANI KUMAR M
	///*******CREATED DATE: 14 th DEC 2017
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 

	this.rosserviceGetROSTemplateLinkedItemsDefaultOptionsList = function (postData) {
		postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHRROS() + "GetROSTemplateLinkedItemsDefaultOptionsList", postData).then(
			function (result) {
				return result;
			});

	};
	/// ################ METHOD TO GET ALL DEFAULT OPTIOS LIST BLOCK END #########################

}]);